import { getMstiTypeColor } from "@src/globalStyles";
import React from "react";
import styled from "styled-components";

export enum MstiTypeComponent {
  Community,
  MyAccount,
  PartResult,
  FullResult,
}

export const MstiType: React.FC<{
  skinType: string;
  componentType: any;
  acneTypeList: any;
}> = ({ skinType, componentType, acneTypeList }) => {
  const MstiSkinTypeWrapper = styled.div`
    display: flex;
    justify-content: center;
    background-color: white;
    padding-top: 10px;
    padding-left: 10px;
  `;
  const MstiSkinTypeHeader = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 31px;
    font-weight: 800;
    background-color: yellow;
    margin-right: 10px;
    border-radius: 13px;
  `;
  const MstiSkinTypePlus = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 31px;
    font-weight: 800;
    margin-right: 10px;
    border-radius: 13px;
  `;

  const MstiSkinTypeAcneWrapper = styled.div`
    display: flex;
    justify-content: end;
    padding: 5px 10px 15px 0;
    background-color: white;
  `;

  const MstiSkinTypeAcne = styled.div``;
  const AcneListItem = styled.li`
    list-style-type: disc;
  `;

  switch (componentType) {
    case MstiTypeComponent.FullResult:
      const runCallback = (cb) => {
        return cb();
      };

      return (
        <>
          <MstiSkinTypeWrapper>
            {runCallback(() => {
              const row = [];
              for (var i = 0; i < 5; i++) {
                row.push(
                  <MstiSkinTypeHeader
                    style={{
                      backgroundColor: getMstiTypeColor(
                        skinType[i].toLocaleLowerCase()
                      )["background"],
                    }}
                    key={i}
                  >
                    {skinType[i]}
                  </MstiSkinTypeHeader>
                );
                if (i == 3) {
                  row.push(<MstiSkinTypePlus>+</MstiSkinTypePlus>);
                }
              }
              return row;
            })}
          </MstiSkinTypeWrapper>
          <MstiSkinTypeAcneWrapper>
            <MstiSkinTypeAcne>
              {acneTypeList.length != 0 && acneTypeList[0] != ""
                ? acneTypeList.map((a) => <AcneListItem>{a}</AcneListItem>)
                : ""}
            </MstiSkinTypeAcne>
          </MstiSkinTypeAcneWrapper>
        </>
      );
  }
};
